import React, { useEffect } from 'react';
import {PageContainer, GuideAppContainer, RenderOnlyFor, PageNavigation, usePages, GuideProgress} from '@ignitesales/neuro-application';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import DetailsPage from './components/pages/DetailsPage';
import Header from './components/Header';
import Footer from './components/Footer';
import { BreakpointProvider } from '@ignitesales/neuro-application/src/neuro-ui';
import { CircularProgressbar } from 'react-circular-progressbar';

const queries = {
  xs: '(min-width: 0px)',
  sm: '(min-width: 600px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1279px)',
  xxl: '(min-width: 1449px)',
  horizontal: '(orientation: landscape)'
};

const App = () => {
  const { isLoadingNextPage } = usePages();

  useEffect(() => {
    if(!isLoadingNextPage) {
      window.scrollTo(0, 0)
    }
  }, [isLoadingNextPage])

  return (
    <BreakpointProvider queries={queries}>
      <GuideAppContainer>
        <Header/>
        <PageContainer
          LandingPage={LandingPage}
          SurveyPage={SurveyPage}
          SummaryPage={SummaryPage}
          DetailsPage={DetailsPage}
        />
        <RenderOnlyFor forSurveyPage>
          <PageNavigation
            toastTimeout={ 2000 }
          />
          <GuideProgress render={ props => <CircularProgressbar className='CircularProgressbar' value={props.progress} text={`${props.progress}%`} /> } />
        </RenderOnlyFor>
        <Footer />
      </GuideAppContainer>
    </BreakpointProvider>
  );
};

export default App;
